export default {
	fillColor: 'white',
	strokeColor: 'gray',
	strokeOpacity: 0.6,
	zIndex: 0,
	strokeWeight: 2.0,
	fillOpacity: 0.4,
}
